import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ConnotePickerSearchDirective } from "./connote-picker-search.directive";
import { ConnotePickerComponent } from "./connote-picker.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ConnotePickerComponent,
    ConnotePickerSearchDirective
  ],
  exports: [
    ConnotePickerComponent,
    ConnotePickerSearchDirective
  ]
})
export class ConnotePickerModule { }
